import React from 'react';
import { Box, Button } from '@mui/material';

interface RangeFilterProps {
  value: string;
  onChange: (rangeKey: string) => void;
}

// Keys must exist in TIME_RANGES.
const OPTIONS = [
  { key: 'month_3', label: '3M' },
  { key: 'month_6', label: '6M' },
  { key: 'ytd', label: 'YTD' },
  { key: 'year_1', label: '1Y' },
  { key: 'year_3', label: '3Y' },
  { key: 'year_5', label: '5Y' },
  { key: 'year_10', label: '10Y' },
];

const RangeFilter = ({ value, onChange }: RangeFilterProps) => (
  <Box sx={{ alignItems: 'center', display: 'flex', gap: 0.5 }}>
    {OPTIONS.map(option => (
      <Button
        key={option.key}
        disableElevation
        color="primary"
        size="small"
        sx={{ fontWeight: 600, minWidth: 0, px: 1 }}
        variant={value === option.key ? 'contained' : 'text'}
        onClick={() => onChange(option.key)}>
        {option.label}
      </Button>
    ))}
  </Box>
);

export default RangeFilter;
